export const USER_PLANS = ['free', 'pro', 'business'] as const;

export type UserPlan = typeof USER_PLANS[number];

export const DEFAULT_USER_PLAN: UserPlan = 'free';

export const USER_PLAN_LABELS_EN: Record<UserPlan, string> = {
  free: 'Free',
  pro: 'Pro',
  business: 'Business',
};
